import { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement> & {
  color?: string;
  size?: number;
};

const SvgThumbUpIcon = ({ color, size = 40, ...props }: Props) => {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="svg-wrapper"
      transform={`scale(${size / 40})`}
      style={{ WebkitTransform: `scale(${size / 40})` }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.647 8.532c-.277-1.8-1.593-3.7-3.888-3.52l-.012.001a3.98 3.98 0 0 0-2.316 1.023 4.136 4.136 0 0 0-1.264 2.227l-.005.026c-.13.73-.313 1.449-.546 2.151a19.265 19.265 0 0 1-2.917 5.16 2.71 2.71 0 0 0-2.01-.893H7.748C6.224 14.707 5 15.969 5 17.512v14.68C5 33.737 6.224 35 7.747 35h3.943c.84 0 1.589-.384 2.092-.988h11.764c1.25 0 2.306-.038 3.213-.379.975-.366 1.675-1.035 2.351-2.032l.003-.004a11.225 11.225 0 0 0 1.395-2.918l1.75-7.045c.262-1.006.36-2.451-.152-3.728a3.898 3.898 0 0 0-1.349-1.749c-.654-.468-1.476-.742-2.46-.795h-.002c-.13-.007-2.087-.01-2.158-.01-.455 0-.965.004-1.492.008-.733.005-1.5.01-2.205.006l.038-.813c.048-1.02.098-2.089.152-2.875l.025-.32c.069-.843.15-1.847-.008-2.826Zm-10.21 23.48h11.109c1.287 0 2-.055 2.532-.255.465-.174.874-.495 1.414-1.29a9.212 9.212 0 0 0 1.12-2.311l1.746-7.03c.194-.742.229-1.716-.072-2.465a1.906 1.906 0 0 0-.659-.868c-.302-.217-.752-.397-1.43-.434h-.035l-.278-.002a326.912 326.912 0 0 0-1.747-.004c-.427 0-.919.003-1.436.006-1.121.008-2.361.016-3.317-.007a.975.975 0 0 1-.7-.321 1.01 1.01 0 0 1-.259-.735c.028-.491.057-1.121.088-1.785.05-1.047.102-2.178.157-2.977v-.007c.01-.112.018-.222.026-.33v-.005c.07-.874.129-1.619.012-2.338l-.002-.01c-.187-1.225-.918-1.904-1.79-1.839-.436.041-.848.224-1.176.522a2.127 2.127 0 0 0-.648 1.135 17.5 17.5 0 0 1-.634 2.475 21.235 21.235 0 0 1-4.022 6.661v14.214Z"
        fill={color || "#595959"}
      />
    </svg>
  );
};

export default SvgThumbUpIcon;
